import React, { useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

import { useRelatedProductsData } from '../../hooks/useRelatedProductsData';
import { RelatedProductsCard } from './ProductCard';
import { RelatedProductsPlaceholder } from './RelatedProductsPlaceholder';
import {
  dataModelRelatedProducts,
  propTypesRelatedProducts
} from './constants';

const productImpressionContainer = {
  id: '',
  component: 'RelatedSearch',
  name: 'RelatedProducts',
  type: 'product'
};

const RelatedProductsComponent = ({
  itemId,
  maxRelatedProducts = 4,
  navParam: propsNavParam = null,
  storeId: propsStoreId = null,
}) => {
  const { customContext } = useContext(ExperienceContext);
  const variables = customContext?.variables || {};
  const {
    navParam: contextNavParam = null,
    storeId: contextStoreId = null
  } = variables || {};
  const navParam = propsNavParam || contextNavParam;
  const storeId = propsStoreId || contextStoreId;

  const { relatedProducts, loading, error } = useRelatedProductsData({
    itemId,
    maxRelatedProducts,
    navParam,
    storeId,
  });

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('related-search.ready');
  }, []);

  if (loading) return (<RelatedProductsPlaceholder />);

  if ((error && !relatedProducts) || !relatedProducts || relatedProducts.length === 0) return null;

  return (
    <ImpressionProvider data={productImpressionContainer}>
      <div className="sui-w-full sui-flex sui-flex-col sui-gap-4" data-component="RelatedProducts">
        <Typography variant="h2">Related Products</Typography>

        <div className="sui-grid xl:sui-grid-cols-6 lg:sui-grid-cols-4 md:sui-grid-cols-4 sui-grid-cols-2 sui-gap-6">
          {relatedProducts.map((product, index) => {
            const { details, identifiers, media } = product || {};
            const { canonicalUrl, productLabel } = identifiers || {};
            const { description } = details || {};
            const { images } = media || {};
            const image = images?.[0];
            const productId = product?.itemId;

            return (
              <RelatedProductsCard
                itemId={productId}
                canonicalUrl={canonicalUrl}
                image={image}
                productLabel={productLabel}
                description={description}
                index={index}
                key={`relatedProduct-${productId}`}
              />
            );
          })}
        </div>
      </div>
    </ImpressionProvider>
  );
};

RelatedProductsComponent.displayName = 'RelatedProducts';

RelatedProductsComponent.propTypes = propTypesRelatedProducts;

RelatedProductsComponent.dataModel = dataModelRelatedProducts;

export { RelatedProductsComponent };